<template>
  <div class="system-progress">
    <template>
      <el-form class="system-progress-header" inline size="small">
        <el-form-item class="mb-0" label="选择时间">
          <el-date-picker v-model="value" type="month" format="yyyy 年 MM 月" value-format="yyyy-MM"
            size="small" @change="getDatesChange" />
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="updateTime()">
            保存修改
          </el-button>
        </el-form-item>
      </el-form>
      <div class="system-progress-holiday">
        <el-table ref="multipleTable" class="jk-table" :data="list" height="100%" border>
          <el-table-column label="日期" align="center" prop="workDay" />
          <el-table-column label="是否节假日" align="center">
            <template #default="{row}">
              <el-checkbox v-model="row.timeType" :true-label="1" :false-label="0" />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>
  </div>
</template>

<script>
import request from "@/CommonDP/service/sysServer-service";
export default {
  name: "HolidaySettings",
  data() {
    return {
      list: [],
      value: ""
    };
  },
  created() {
    this.initData();
  },
  methods: {
    getDatesChange(value) {
      const arr = value.split("-");
      const params = {
        yearTime: arr[0],
        monthTime: arr[1]
      };
      console.log(params);
      request.getDates(params).then((res) => {
        if (res.result == "0") {
          this.list = res.data;
        } else {
          this.$warning(res.message);
        }
      });
    },

    updateTime() {
      request
        .updateDates(this.list)
        .then((res) => {
          if (res.result == "0") {
            this.$message({
              message: "修改成功",
              type: "success"
            });
          } else {
            this.$warning(res.message);
          }
        })
        .finally(() => {
          this.getDatesChange(this.value);
        });
    },
    initData() {
      // 获取当前时间
      // 获取当前时间
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      this.value = year.toString() + "-" + month.toString();
      this.getDatesChange(this.value);
    }
  }
};
</script>
<style lang="scss" scoped>
.system-progress {
  display: flex;
  flex-flow: column nowrap;
  // justify-content: flex-start;
  height: 100%;

  &-header {
    flex: 0 0;
    background-color: #fff;
    padding: var(--middle-space) var(--big-space) 0;
  }
  &-footer {
    flex: 0 0;
    background-color: #fff;
    padding: var(--middle-space) var(--big-space);
  }

  &-body {
    flex: 1 1;
    position: relative;
    background-color: #fff;
    .pdf-c {
      color: brown;
      cursor: pointer;
    }
    .row-btn-info {
      color: #2f6cdf;
    }
  }
  &-holiday {
    padding: 0 var(--big-space) var(--middle-space);
    height: 1px;
    flex: 1 1;
    position: relative;
    background-color: #fff;
    .pdf-c {
      color: brown;
      cursor: pointer;
    }
    .row-btn-info {
      color: #2f6cdf;
    }
  }
}
</style>
